module.exports = __webpack_public_path__ + "img/role_sad.5ad77524.png";